import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import AdditionalWorkTable from "./AdditionalWorkTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import CreateAdditionalWorkModel from "./CreateAdditionalWorkModel"

function AdditionalWorkList() {
  document.title = `Additional Work | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()

  const navigate = useNavigate()

  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [displayStart, setDisplayStart] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [userFilter, setUserFilter] = useState(0)
  const [users, setUsers] = useState([])
  const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
  const [dateDisble, setdateDisble] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalSuccessCount, setTotalSuccessCount] = useState(0)
  const [totalFailCount, setTotalFailCount] = useState(0)

  // filter data for user
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }

  useEffect(() => {
    getApi('User/user-lookup').then(({ data, status }) => {
      if (status === 200) {
        setUsers(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])

  // user list api
  const AdditionalWorkListApi = () => {
    setIsLoading(true)
    setScreenLoad(true)
    postApi("Common/additional-work/list", {
      fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
        dateFilter[0],
        "yyyy-MM-dd"
      ) : new Date().toISOString().slice(0, 10),
      toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
        dateFilter[1],
        "yyyy-MM-dd"
      ) : new Date().toISOString().slice(0, 10),
      userId: parseInt(userFilter),
      displayStart: displayStart,
      pageSize: rowsPerPage,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        setTableData(data.NoteList)
        setTotalRecords(data.TotalRecords)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })
  }

  // user list api useEffect
  useEffect(() => {
    if (dateFilter[1] != undefined) {
      AdditionalWorkListApi()
    }
  }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble])

  // Delete user handler
  const handleDelete = Id => {
    setScreenLoad(true)
    if (Id) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this additional work permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/additional-work/delete?id=${Id}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== Id ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Additional Work",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }


  // Update user handler
  const handleEditCustomer = customerData => {
    if (customerData) {
      setEditData(customerData)
      setIsEdit(true)
      setModal(!modal)
    }
  }

  // Create user handler
  const handleCustomerAttendClick = () => {
    setIsEdit(false)
    toggle()
  }

  // popup box handler
  const toggle = () => {
    setModal(!modal)
  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Note",
        accessor: "Note",
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "15%"
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "10%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "8%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">

              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditCustomer(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  function writeDataToExcel() {
    if (!dateDisble) {
      toast.error("Please Select date", {
        icon: "⚠️",
        style: {
          fontSize: "15px",
        },
      })
    } else {
      setIsLoading(true)
      let header = ["Note", "Created By", "Created On"];
      const mainTitle = "Additional Work";
      const widthObj = [{
        Key: "A",
        Value: 35,
      },
      {
        Key: "B",
        Value: 25,
      },
      {
        Key: "C",
        Value: 18,
      },
      ]
      const extention = "Additional_Work.xlsx"
      let excelSheetData = []

      postApi("Common/additional-work/list", {
        fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
          dateFilter[0],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
          dateFilter[1],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        userId: parseInt(userFilter),
        displayStart: displayStart,
        pageSize: 100000,
        searchText: searchText.trim(),
        sortColumn: "",
        sortOrder: "asc",
      }).then(({ data, status }) => {
        if (status === 200) {
          for (let index = 0; index < data?.NoteList.length; index++) {
            let dataObj = {
              Note: data?.NoteList[index].Note,
              CreatedByName: data?.NoteList[index].CreatedByName,
              CreatedOn: data?.NoteList[index].CreatedOn == null
                ? "N/A"
                : dateFormat(data?.NoteList[index].CreatedOn, "dd-MM-yyyy"),
            }
            excelSheetData.push(dataObj)
          }
          var fields = Object.keys(excelSheetData[0]);
          var sheetData = excelSheetData.map(function (row) {
            return fields.map(function (fieldName) {
              return row[fieldName];
            });
          });
          setIsLoading(false)
          sheetData.unshift(header);
          exportDataExcel(sheetData, mainTitle, widthObj, extention)
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
        setIsLoading(false)
        setScreenLoad(false)
      })

    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <AdditionalWorkTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleCustomerAttendClick={handleCustomerAttendClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
              pagePerSize={pagePerSize}
              setDateFilter={setDateFilter}
              dateFilter={dateFilter}
              users={users}
              userFilter={userFilter}
              setUserFilter={setUserFilter}
              setdateDisble={setdateDisble}
              dateDisble={dateDisble}
              writeDataToExcel={writeDataToExcel}
              totalFailCount={totalFailCount}
              totalSuccessCount={totalSuccessCount}
            />

            <CreateAdditionalWorkModel
              modal={modal}
              toggle={toggle}
              AdditionalWorkListApi={AdditionalWorkListApi}
              isEdit={isEdit}
              editData={editData}
            />

          </CardBody>
        </Card>
      </div>
    </div>
  )
}
AdditionalWorkList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default AdditionalWorkList
